export const LOCALES = {
  EN_US: 'en-US',
  JA: 'ja',
  KO: 'ko',
  ZH_HANS: 'zh-Hans',
} as const;

export const LOCALE_TO_COUNTRY_MAP = {
  'en-US': 'US',
  ko: 'KO',
  ja: 'JA',
  'zh-Hans': 'CN',
};

export type LocalesUnion = (typeof LOCALES)[keyof typeof LOCALES];

export const WORDS_PER_MINUTE = {
  'en-US': 228,
  ja: 193,
  ko: 202,
  'zh-Hans': 158,
};

export const LOCALES_ARR: LocalesUnion[] = Object.values(LOCALES);

export const LOCALE_LANG_TO_LOCALE: Map<string, LocalesUnion> = LOCALES_ARR.reduce(
  (acc, locale) => acc.set(locale.slice(0, 2), locale),
  new Map()
);
